<template>
	<CreationWizardStepWrapper>
		<template #header>
			<ChooseProjectAndFeatureTypeHeader v-bind="$props" v-on="$listeners" />
		</template>
		<FeatureTypeSelectorDataProvider
			@click="onClick"
			:disabledTabs="disabledTabs"
			:disabled="!selectedProjectId"
			v-model="_selectedFeatureType"
			:selectedTabIndex.sync="_selectedTabIndex"
		/>
	</CreationWizardStepWrapper>
</template>

<script>
import props from './ChooseProjectAndFeatureType.props';
import ChooseProjectAndFeatureTypeHeader from './ChooseProjectAndFeatureTypeHeader.vue';
import FeatureTypeSelectorDataProvider from './FeatureTypeSelector/FeatureTypeSelectorDataProvider.vue';
import WizardStepMixin from '../WizardStepMixin';
export default {
	name: 'ChooseProjectAndFeatureType',
	props,
	mixins: [WizardStepMixin],
	components: { FeatureTypeSelectorDataProvider, ChooseProjectAndFeatureTypeHeader },
	computed: {
		_selectedFeatureType: {
			get() {
				return this.selectedFeatureTypeId;
			},
			set(typeId) {
				this.updateState({ key: 'selectedFeatureTypeId', value: typeId });
			},
		},
		_selectedTabIndex: {
			get() {
				return this.selectedTabIndex;
			},
			set(value) {
				this.updateState({ key: 'selectedTabIndex', value });
			},
		},
	},
	methods: {
		onClick() {
			this.$nextTick(() => {
				this.nextStep();
			});
		},
	},
};
</script>

<style lang="scss" scoped></style>
